// extracted by mini-css-extract-plugin
export default {"teamCards":"Game_teamCards__0MDVb","roundCompleteButton":"Game_roundCompleteButton__j4LDc","teamCard":"Game_teamCard__5OfG9"};